import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CanComponentDeactivate } from '@fry/components/common/form';
import { FormData } from '@fry/lib/forms';
import { NotifyService } from '@fry/lib/utils';
import { UserField } from '@fry/lib/user-fields';
import { UserFieldForm } from '@fry/components/user-fields/user-field.form';

@Component({
    selector: 'app-user-field-edit',
    templateUrl: './user-field-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserFieldEditComponent implements OnInit, OnDestroy, CanComponentDeactivate {

  public userField: UserField;
  public formData$: Observable<FormData>;

  private destroyed$ = new Subject<void>();

  constructor(
    private form: UserFieldForm,
    private route: ActivatedRoute,
    private notify: NotifyService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.route.data.pipe(takeUntil(this.destroyed$)).subscribe(
      data => {
        this.userField = data.userField;
        this.formData$ = this.form.init(this.userField);
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
      this.form.submit(this.userField)
               .pipe(takeUntil(this.destroyed$))
               .subscribe(
        data => {
          this.userField = data;
          this.notify.success($localize `User successfully field saved`);
          this.router.navigate(['user-fields']);
        },
        error => this.notify.error(error)
      );
  }

  canSafelyDeactivate() {
    return this.form.pristine;
  }
}
